module.exports = __webpack_public_path__ + "assets/ba4b7c96987e06b142656a3a1f02d1a4.svg";